import { atom } from 'jotai';

export const debugObjectsRawAtom = atom<Record<string, any>>({});

export const debugObjectsAtom = atom<Record<string, any>, [Record<string, any>], Record<string, any>>(
  get => get(debugObjectsRawAtom),
  (get, set, change) => {
    const prev = get(debugObjectsRawAtom);
    const res = {
      ...prev,
      ...change,
    };
    set(debugObjectsRawAtom, res);
    return res;
  },
);

export const axiosErrorsAtom = atom<
  Array<{
    when: Date;
    url: string;
    method: string;
    status: number;
    statusText: string;
    details: { payload: string; response: string };
  }>
>([]);
